"use client";

import { ComponentProps, FC, PropsWithChildren } from "react";

import { useDirection } from "@jti/fe-common";
import { ConfigProvider } from "@jti/ui/providers/ConfigProvider";

import {
  PageConfigContext,
  PageConfigProvider,
} from "@/context/PageConfigContext";

type ConfigProviderProps = ComponentProps<typeof ConfigProvider>;

type PageModelProvidersProps = {
  locale: string;
  pageConfig: PageConfigContext;
  configuration: ConfigProviderProps["config"];
  dictionary: ConfigProviderProps["translations"];
};

export const ClientProviders: FC<
  PropsWithChildren<PageModelProvidersProps>
> = ({ locale, pageConfig, dictionary, configuration, children }) => {
  const direction = useDirection();

  return (
    <ConfigProvider
      locale={locale}
      config={configuration}
      translations={dictionary}
      direction={direction}
    >
      <PageConfigProvider value={pageConfig}>{children}</PageConfigProvider>
    </ConfigProvider>
  );
};
